import { useState } from "react";
import { useForm } from "react-hook-form";
import { IconX } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { T, useLanguage } from "../../../context/LanguageContext";

import AddOutSourceModal from "./AddOutSourceModal";
import { useOutSourceCreateMutation } from "../../../apis/outSourceApis";

interface Props {
  onClose: () => void;
}

export default function AddOutSourceSidebar({ onClose }: Props) {
  const { t } = useLanguage();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useOutSourceCreateMutation();

  const [selectedDocument, setSelectedDocument] = useState<any>({
    vatDoc: false,
    crDoc: false,
    contractDoc: false,
    companyLogo: false,
  });

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<any>();

  const handleCreate = (data: any) => {
    mutate(
      { ...data },
      {
        onSuccess: () => {
          toast.success(t("Outsource Added Successfully."));
          reset();
          setSelectedDocument({
            vatDoc: false,
            crDoc: false,
            contractDoc: false,
            companyLogo: false,
          });
          queryClient.invalidateQueries({ queryKey: ["outSourcesData"] });
          onClose();
        },
        onError: (error: any) => {
          console.error(error, "error");
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === "string" ? error : null) ||
            "Something went wrong";

          toast.error(t(errorMessage));
        },
      },
    );
  };

  return (
    <div className="relative bg-white rounded-3xl shadow-sm border flex flex-col overflow-hidden ">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
        <h2 className="text-xl font-semibold text-[#212121]">
          <T>Add Company</T>
        </h2>

        <div className="flex items-center gap-3">
          <button
            onClick={handleSubmit(handleCreate)}
            disabled={isPending}
            className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg disabled:opacity-50"
          >
            {isPending ? t("Adding...") : t("Add")}
          </button>

          <button
            onClick={onClose}
            className="p-2 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>
 
        <AddOutSourceModal
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          setSelectedDocument={setSelectedDocument}
        /> 
    </div>
  );
}
